import React from 'react';
import Helmet from 'react-helmet';

function Seo({ description, lang = 'en', meta = [], keywords = [], title, canonical = true, ...props }) {
	const metaDescription = description || props.ogDescription;
	if (props.metaRobotsNofollow === "follow") {
		props.metaRobotsNofollow += ", max-snippet:-1, max-image preview:large, max-video-preview:-1";
	}

	title = title
				?.replace(/2021|2022|2023|2024/g, new Date().getFullYear())
				?.replace(/robot lawyer/gi, "AI Consumer Champion")
				?.replace(/\d{2,3}% Success(?: Rate)?/g, "Best Results")
				.trim();

	if (props.seoTitle) {
		props.seoTitle = props.seoTitle
									?.replace(/2021|2022|2023|2024/g,new Date().getFullYear())
									?.replace(/robot lawyer/gi, "AI Consumer Champion")
									?.replace(/\d{2,3}% Success(?: Rate)?/g, "Best Results")
									.trim();
	}

	if (props.ogTitle) {
		props.ogTitle = props.ogTitle
								?.replace(/2021|2022|2023|2024/g, new Date().getFullYear())
								?.replace(/robot lawyer/gi, "AI Consumer Champion")
								?.replace(/\d{2,3}% Success(?: Rate)?/g, "Best Results")
								.trim();
	}

	if (props.ogDescription) {
		props.ogDescription = props.ogDescription
											?.replace(/2021|2022|2023|2024/g, new Date().getFullYear())
											?.replace(/robot lawyer/gi, "AI Consumer Champion")
											?.replace(/\d{2,3}% Success(?: Rate)?/g, "Best Results")
											.trim();
	}

	return (
		<Helmet
			htmlAttributes={{
				lang,
			}}
			title={props.seoTitle ? props.seoTitle : title}
			titleTemplate={`%s`}
			meta={[
				metaDescription
					? {
						name: `description`,
						content: metaDescription,
					}
					: {},
				props.metaRobotsNofollow && props.metaRobotsNoindex
					? {
						name: `robots`,
						content: props.metaRobotsNoindex + ', ' + props.metaRobotsNofollow,
					}
					: props.metaRobotsNofollow
						? {
							name: `robots`,
							content: props.metaRobotsNofollow,
						}
						: props.metaRobotsNoindex
							? {
								name: `robots`,
								content: props.metaRobotsNoindex,
							}
							: {},
				props.ogTitle
					? {
						property: `og:title`,
						content: props.ogTitle,
					}
					: {},
				props.ogDescription
					? {
						property: `og:description`,
						content: props.ogDescription,
					}
					: {},
				props.ogType
					? {
						property: `og:type`,
						content: props.ogType,
					}
					: {},
				props.ogSiteName
					? {
						property: `og:site_name`,
						content: props.ogSiteName,
					}
					: {},
				{
					property: `og:image`,
					content: 'https://donotpay-assets.s3-us-west-2.amazonaws.com/LcSocial.png',
				},
				{
					name: `twitter:card`,
					content: `summary`,
				},

				title
					? {
						name: `twitter:title`,
						content: title,
					}
					: {},
				props.ogURL
					? {
						property: `og:url`,
						content: props.ogURL,
					}
					: {},
				metaDescription
					? {
						name: `twitter:description`,
						content: metaDescription,
					}
					: {},
				// props.ogPublishedTime
				// 	? {
				// 		property: `article:published_time`,
				// 		content: props.ogPublishedTime,
				// 	}
				// 	: {},
				// props.ogModifiedTime
				// 	? {
				// 		property: `article:modified_time`,
				// 		content: props.ogModifiedTime,
				// 	}
				// 	: {},
			]
				.concat(
					keywords.length > 0
						? {
							name: `keywords`,
							content: keywords.join(`, `),
						}
						: [],
				)
				.concat(meta)}


		>

			<link
				rel="icon"
				href="https://donotpay-assets.s3-us-west-2.amazonaws.com/dnp-logo.png"
				type="image/icon type"
			></link>
			{/* <link
				rel="apple-touch-icon"
				sizes="48x48"
				href="https://donotpay.com/learn/icons/icon-48x48.png?v=e9373ae8d23b2a86a0f543f9794b3bea"
			/>
			<link
				rel="apple-touch-icon"
				sizes="72x72"
				href="https://donotpay.com/learn/icons/icon-72x72.png?v=e9373ae8d23b2a86a0f543f9794b3bea"
			/> */}
			{/* <link
				rel="apple-touch-icon"
				sizes="96x96"
				href="https://donotpay.com/learn/icons/icon-96x96.png?v=e9373ae8d23b2a86a0f543f9794b3bea"
			/>
			<link
				rel="apple-touch-icon"
				sizes="144x144"
				href="https://donotpay.com/learn/icons/icon-144x144.png?v=e9373ae8d23b2a86a0f543f9794b3bea"
			/> */}
			{/* <link
				rel="apple-touch-icon"
				sizes="192x192"
				href="https://donotpay.com/learn/icons/icon-192x192.png?v=e9373ae8d23b2a86a0f543f9794b3bea"
			/> */}
			{/* <link
				rel="apple-touch-icon"
				sizes="256x256"
				href="https://donotpay.com/learn/icons/icon-256x256.png?v=e9373ae8d23b2a86a0f543f9794b3bea"
			/> */}
			{/* <link
				rel="apple-touch-icon"
				sizes="384x384"
				href="https://donotpay.com/learn/icons/icon-384x384.png?v=e9373ae8d23b2a86a0f543f9794b3bea"
			/> */}
			{/* <link
				rel="apple-touch-icon"
				sizes="512x512"
				href="https://donotpay.com/learn/icons/icon-512x512.png?v=e9373ae8d23b2a86a0f543f9794b3bea"
			/> */}

			<link
				rel="icon"
				type="image/png"
				sizes="192x192"
				href="https://donotpay.com/learn/icons/android-icon-192x192.png"
			/>
			<link
				rel="icon"
				type="image/png"
				sizes="32x32"
				href="https://donotpay.com/learn/icons/favicon-32x32.png"
			/>
			<link
				rel="icon"
				type="image/png"
				sizes="96x96"
				href="https://donotpay.com/learn/icons/favicon-96x96.png"
			/>
			<link
				rel="icon"
				type="image/png"
				sizes="16x16"
				href="https://donotpay.com/learn/icons/favicon-16x16.png"
			/>
			{canonical && (
				<link
					rel="canonical"
					href={
						props.slug === 'cbs-all-access-free-trial-2'
							? 'https://donotpay.com/learn/cbs-all-access-free-trial/'
							: props.slug !== 'main'
								? 'https://donotpay.com/learn/' + props.slug + '/'
								: 'https://donotpay.com/learn/'
					}
				/>
			)}
		</Helmet>
	);
}

export default React.memo(Seo);
